import React from 'react';
import { observer } from 'mobx-react';
import * as IoC from 'typescript-ioc';
import Text from '../../../../global/text/text';
import { IEventAttributeDetailsDTO, EventAttributeTypesLabels } from '../../../../../api/attributes.dao';
import { DateTimeFormatter } from '../../../../../infrastructure/implementations/date-formatter';
import classNames from 'classnames';
import './event-attributes-list-item.scss';
import { hasPermission } from '../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../api/roles.dao';
import DefaultButton from '../../../../global/default-button/default-button';
import { editText } from '../../../../../constants/common-labels.constants';

export type IEventAttributesListItemProps = {
    item: IEventAttributeDetailsDTO;
    onEdit?: (eventAttributeId: number) => void;
};

export const EventAttributesListItem = observer((props: IEventAttributesListItemProps): JSX.Element => {
    const { item, onEdit } = props;

    const dateFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);
    const creationDate = dateFormatter.dateToLocalStringFormat(
        new Date(item.createdAt),
        DateTimeFormatter.localTimeZone,
        dateFormatter.getLocalTimeFormat(),
    );

    const hasEditPermission = hasPermission(Permission.MANAGE_EVENT_ATTRIBUTES);
    const canEdit = hasEditPermission && !!onEdit;

    const handleEditClick = () => {
        if (canEdit) {
            onEdit(item.eventAttributeId);
        }
    };

    const cellEffectClasses = classNames({
        'hoverable': canEdit,
    });

    const inputTypeLabel = EventAttributeTypesLabels[item.inputType as keyof typeof EventAttributeTypesLabels] || item.inputType;

    return (
       <tr
            className={classNames('attribute-item', {'attribute-item__not-active': !item.active})}
            onDoubleClick={canEdit ? handleEditClick : undefined}
        >
            <Text tag='td' className={cellEffectClasses} message={item.eventAttributeName} withEllipsis />
            <Text tag='td' className={cellEffectClasses} message={item.description} withEllipsis />
            <Text tag='td' className={cellEffectClasses} message={inputTypeLabel} withEllipsis />
            <Text tag='td' className={cellEffectClasses} message={creationDate} />
             <td className={cellEffectClasses}>
                <div className='role-item__column role-item__description'>
                    <div className='role-item__description-content'>
                          <Text className='role-item__text' message={item.active ? 'Active' : 'Inactive'} withEllipsis />
                    </div>
                    {canEdit && (
                        <DefaultButton
                            className='visible-while-hovered'
                            modifier='slim'
                            text={editText()}
                            onClick={handleEditClick}
                        />
                    )}
                </div>
            </td>
        </tr>
    );
});
